import React from 'react';

const Footer = (): JSX.Element => {
  return (
    <div className='h-10 w-full fixed bottom-0 bg-black'></div>
  );
};

export default Footer;
